import React from 'react';
import { bool, func } from 'prop-types';
import Translate from '@client/components/shared/translation/Translate';
import CSSModules from 'react-css-modules';
import styles from './doiSuccessResendLink.scss';

export function DoiSuccessResendLink({ isLoading, onClick }) {
    return isLoading ? (
        <Translate message="sending" />
    ) : (
        <a href="#" onClick={onClick} styleName="resend-link">
            <Translate message="resendEmail" />
        </a>
    );
}

DoiSuccessResendLink.propTypes = {
    isLoading: bool,
    onClick: func.isRequired,
};

DoiSuccessResendLink.defaultProps = {
    isLoading: false,
};

export default CSSModules(DoiSuccessResendLink, styles);
